export default function(http) {
  return {
      queryByPage(data){
        return http.json({
          url: `/paper/problemCustomer/query`,
          data
        });
      },
  };
}



// WEBPACK FOOTER //
// ./src/configure/http/api/paperProblemCustomer.js